import {
  INDUSTRIAL_WAREHOUSE,
  RETAIL,
  OFFICES,
  LAND_DEVELOPMENT,
  SHOWROOMS_BULKY_GOODS,
  HOTEL_LEISURE,
  MEDICAL_CONSULTING,
  OTHER,
  COMMERCIAL_FARMING,
} from '../../../shared/model/constants/propertyTypes';

export const preparePropertyType = propertyType => ({
  id: propertyType.id,
  title: propertyType.longDisplayText,
  icon: propertyType.iconName,
  path: propertyType.url,
});

export const DEFAULT_ITEMS = [
  INDUSTRIAL_WAREHOUSE,
  RETAIL,
  OFFICES,
  LAND_DEVELOPMENT,
  SHOWROOMS_BULKY_GOODS,
  HOTEL_LEISURE,
  MEDICAL_CONSULTING,
  COMMERCIAL_FARMING,
  OTHER,
];

const RETAIL_SHOWROOM = {
  id: RETAIL.id,
  longDisplayText: 'Retail & Showroom',
  iconName: RETAIL.iconName,
  url: `?propertyTypes=${RETAIL.url},${SHOWROOMS_BULKY_GOODS.url}`,
};

// TODO: [CAROUSELCLEANUP] Reinstate these invest options
export const INVEST_ITEMS = [
  INDUSTRIAL_WAREHOUSE,
  OFFICES,
  RETAIL_SHOWROOM,
  MEDICAL_CONSULTING,
  HOTEL_LEISURE,
];
